import fetcher from 'api/fetcher';
import { Campaign } from 'utils/campaign';

export const fetchCampaignInfo = (campaignId: number, abortSignal: AbortSignal): Promise<Campaign> =>
    fetcher.get<unknown, Campaign>(`/api/v1/campaigns/${campaignId}`, {
        signal: abortSignal,
        timeout: 30000,
    });
